import type { ReactNode } from 'react';
import { Modal, Text } from '@simplywallst/ui-core';

interface Props {
  title: string;
  description: ReactNode;
  onClose: () => void;
}

export const InformationModal = ({ title, description, onClose }: Props) => {
  return (
    <Modal title={title} onSecondaryClick={onClose} secondaryLabel="Close">
      {typeof description === 'string' ? (
        <Text color="inherit" typography="xSmall">
          {description}
        </Text>
      ) : (
        description
      )}
    </Modal>
  );
};
